'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../../../assets/stylus/main.styl');

var _CommonBg = require('../component/common/CommonBg');

var _CommonBg2 = _interopRequireDefault(_CommonBg);

var _CNZZ = require('../component/common/CNZZ');

var _reactRedux = require('react-redux');

var _auth = require('../../reducers/auth');

var _CookieUtil = require('../../util/CookieUtil');

var _CookieUtil2 = _interopRequireDefault(_CookieUtil);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var timer = void 0;

var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        var _temp, _this, _ret;

        _classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.sendSessionId = function (id, ssid) {
            var type = _this.props.location.query.type;

            type === '' ? 1 : type;
            //如果是浏览器，检查是否超过授权数
            if (navigator.appVersion.indexOf('Electron') === -1) {
                _this.props.checkAllowNum(id, ssid, type);
            }
            //如果是浏览器端，轮询发送在线请求
            if (navigator.appVersion.indexOf('Electron') === -1) {
                timer = setInterval(function () {
                    if (_this.props.location.pathname !== '/overPaid' && _this.props.location.pathname !== '/403') {
                        _this.props.sendOnlineRequest(id, ssid, type);
                    }
                }, 10000);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    App.prototype.componentDidMount = function () {
        function componentDidMount() {
            (0, _CNZZ.TrackPageview)(window.location.pathname);
            if (this.props.location.pathname === '/403') {
                return;
            }
            /*验证ssid*/
            //获取url中的参数
            var _props$location$query = this.props.location.query,
                ssid = _props$location$query.ssid,
                type = _props$location$query.type;
            //如果url中不存在ssid，则获取cookie中的ssid

            if (!ssid) {
                ssid = _CookieUtil2.default.get('ssid');
            }
            //如果url和cookie中都不存在ssid，则跳转403
            if (!ssid) {
                _reactRouter.browserHistory.push('/403');
                return;
            }
            //如果存在ssid，查看是否授权
            this.props.auth(ssid, type, this.sendSessionId);
        }

        return componentDidMount;
    }();

    App.prototype.componentWillUnmount = function () {
        function componentWillUnmount() {
            clearInterval(timer);
        }

        return componentWillUnmount;
    }();

    App.prototype.componentDidUpdate = function () {
        function componentDidUpdate() {
            (0, _CNZZ.TrackPageview)(window.location.pathname);
        }

        return componentDidUpdate;
    }();

    App.prototype.render = function () {
        function render() {
            var pathname = this.props.location.pathname;
            return _react2.default.createElement(
                'div',
                { id: 'application', className: 'position-rl' },
                pathname === "/" || pathname === "/403" || pathname === "/overPaid" ? this.props.children : _react2.default.createElement(
                    _CommonBg2.default,
                    { pathname: pathname },
                    this.props.children
                )
            );
        }

        return render;
    }();

    return App;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        auth: state.auth
    };
}, {
    auth: _auth.auth,
    sendOnlineRequest: _auth.sendOnlineRequest,
    checkAllowNum: _auth.checkAllowNum
})(App);


//////////////////
// WEBPACK FOOTER
// ./src/ui/container/App.js
// module id = 507
// module chunks = 0